import { Component, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './shared/services/auth.service';
import { StorageService } from './shared/services/storage.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
})
export class App {
  protected readonly title = signal('fieldQ');
  currentURL: any;
  constructor(
    private readonly router: Router,
    private readonly _auth: AuthService,
    private readonly _storage: StorageService,
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd): any => {
        this.currentURL = event.urlAfterRedirects;
      });
    setTimeout(() => {
      const token = localStorage.getItem('adminToken') ?? '';
      if (token && this.currentURL == undefined) {
        this.getProfile();
      }
    }, 5000);
  }

  private getProfile(): void {
    this._auth.getUserProfile().subscribe({
      next: (res: any) => {
        if (res?.role == 'User') {
          this.router.navigate(['/agent/chat']);
        } else {
          this.router.navigate(['/kpi-explorer']);
        }
      },
      error: (err: any) => {},
    });
  }

  async ngAfterViewInit() {
    setTimeout(async () => {
      if (this._storage.getBrowser()) {
        const { default: AOS } = await import('@reimujs/aos');
        AOS.init({
          duration: 800,
          easing: 'ease-in-out',
          once: false,
        });
        AOS.refresh();
      }
    }, 2000); // 2 seconds
  }
}
